import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'deleteAccount'

export default (userId) => (asyncAction(
  name,
  AuthService.deleteAccount,
  { userId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/deleteAccount.js